import * as z from "zod"

import { jsonDbAtom } from "@axtesys/react-tools"

import {
  padCashRegisterPart,
  padReceiptPart,
} from "~shared/feature/Receipt/lib"
import { selector } from "~shared/lib/recoil/lib"

import { cashRegisterState } from "../CashRegister/state"

export const cashFlowReceiptCountState = jsonDbAtom({
  key: "cashFlowReceiptCount",
  default: 1,
  schema: z.number(),
})

// The effective `receiptNumber` we print on the receipt.
// Something like "K02-EA-000124".
export const cashFlowReceiptNumberSelector = selector({
  key: "cashFlowReceiptNumber",
  get: ({ get }) => {
    const { cashRegisterNumber } = get(cashRegisterState)
    const receiptNumber = get(cashFlowReceiptCountState)

    const registerPart = padCashRegisterPart(cashRegisterNumber.toString())
    const receiptPart = padReceiptPart(receiptNumber.toString())

    return `K${registerPart}-EA-${receiptPart}`
  },
})
